import React from "react";
import { Braces, FileText } from "lucide-react";
import ReactJson from "@microlink/react-json-view";

const normalizeBreaks = (s) => String(s ?? "").replace(/\\r\\n|\\n|\\r|\r\n|\r|\n/g, "\n");

const parseIfJson = (val) => {
	if (val == null) return null;
	if (typeof val === "object") return val;
	if (typeof val === "string") {
		const t = val.trim();
		if ((t.startsWith("{") && t.endsWith("}")) || (t.startsWith("[") && t.endsWith("]"))) {
			try {
				return JSON.parse(t);
			} catch {
				return null;
			}
		}
	}
	return null;
};

/**
 * JsonCell
 * Props:
 * - message: string | object (texto prioritario si existe)
 * - raw: string | object (message_response)
 * - json: string | object (message_response_json)
 * - initialMode: 'auto' | 'raw' | 'json' (por defecto 'auto')
 * - className: string
 * - style: object
 * - maxWidth: number (default 300)
 * - labels: { rawButton?: string, jsonButton?: string }
 */
const JsonCell = ({
	message,
	raw,
	json,
	initialMode = "auto",
	className = "",
	style = {},
	maxWidth = 300,
	labels = {
		rawButton: "Ver respuesta procesada",
		jsonButton: "Ver respuesta ",
	},
}) => {
	const parsedJson = React.useMemo(() => parseIfJson(json), [json]);

	const startMode = initialMode === "raw" ? "raw" : initialMode === "json" ? (parsedJson ? "json" : "raw") : parsedJson ? "json" : "raw"; // auto

	const [mode, setMode] = React.useState(startMode);
	const toggleMode = () => setMode((m) => (m === "json" ? "raw" : "json"));

	return (
		<div className={className} style={{ maxWidth, ...style }}>
			{message ? (
				typeof message === "object" ? (
					<ReactJson src={message} collapsed={true} name={false} enableClipboard={false} displayDataTypes={false} />
				) : (
					<pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>{String(normalizeBreaks(message))}</pre>
				)
			) : null}

			<div style={{ marginTop: message ? 6 : 0, marginBottom: 6 }}>
				<button
					onClick={toggleMode}
					style={{
						fontSize: 12,
						padding: "2px 6px",
						border: "1px solid #ddd",
						borderRadius: 4,
						background: "#f7f7f7",
						cursor: "pointer",
						display: "inline-flex",
						gap: 6,
						alignItems: "center",
					}}
					title={mode === "json" ? labels.rawButton : labels.jsonButton}
				>
					{mode === "json" ? <FileText size={14} /> : <Braces size={14} />}
					{mode === "json" ? labels.rawButton : labels.jsonButton}
				</button>
			</div>

			{mode === "json" ? (
				parsedJson ? (
					<ReactJson src={parsedJson} collapsed={true} name={false} enableClipboard={false} displayDataTypes={false} />
				) : (
					<small style={{ color: "#999" }}>No hay respuesta disponible.</small>
				)
			) : raw ? (
				typeof raw === "object" ? (
					<ReactJson src={raw} collapsed={true} name={false} enableClipboard={false} displayDataTypes={false} />
				) : (
					<pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>{String(normalizeBreaks(raw))}</pre>
				)
			) : (
				<span>-</span>
			)}
		</div>
	);
};

export default JsonCell;
